import type { DateRange } from "react-day-picker";

export type DatePreset = "today" | "7d" | "30d" | "custom";

export const DATE_PRESET_OPTIONS: { value: DatePreset; label: string }[] = [
  { value: "today", label: "Today" },
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "custom", label: "Custom range" },
];

export function rangeForPreset(
  preset: DatePreset,
  fallback?: DateRange
): DateRange | undefined {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (preset === "today") return { from: today, to: today };
  if (preset === "7d") {
    const from = new Date(today);
    from.setDate(today.getDate() - 6);
    return { from, to: today };
  }
  if (preset === "30d") {
    const from = new Date(today);
    from.setDate(today.getDate() - 29);
    return { from, to: today };
  }
  return fallback;
}
